export const PRODUCT_CHASE_COVER = {
  label: 'Chase Cover',
  value: 'PRODUCT_CHASE_COVER'
};
